import { render, staticRenderFns } from "./VendorBlacklistConfirmationModal.vue?vue&type=template&id=702a96a8&"
import script from "./VendorBlacklistConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./VendorBlacklistConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports